<script lang="ts" setup>
import ProductBlock from '~/widgets/search/product/ProductBlock.vue'
import TableBlock from '~/widgets/search/product/TableBlock.vue'
import SeoProductDescription from '~/entities/products/SeoProductDescription.vue'
import useMainStore from '~/shared/store'
import useSearchStore from '~/shared/store/modules/search'
import FullScreenSlider from '~/components/ui/slider/FullScreenSlider.vue'
import Breadcrumbs from '~/components/ui/breadcrumbs/Breadcrumbs.vue'
import { useMonitorSize } from '~/composables/monitor-size'
import type { IMonitorSize } from '~/shared/interfaces/composables'
import type { IProduct } from '~/shared/interfaces/search/product'
import type { IBreadcrumbs } from '~/shared/interfaces/ui/breadcrumbs'

definePageMeta({
  layout: 'product',
})

const mainStore = useMainStore()
const searchStore = useSearchStore()

let product: IProduct | null = null
let breadcrumbsList: IBreadcrumbs[] = []
let sizes: IMonitorSize | null = useMonitorSize()

async function getProductInfo() {
  mainStore.setContentLoadingStatus(false)
  const { data, status } = await useFetch(`/api/search/product/${useRoute().params.id}`)
  if (data.value) {
    product = data.value
  } else {
    throw createError({ statusCode: 404, statusMessage: 'Page Not Found', fatal: true })
  }

  if (product?.breadcrumbs.length) {
    const { breadcrumbs, productInfo } = product
    breadcrumbsList = [
      {
        uuid: 'catalog',
        name: 'Каталог',
        slug: 'catalog',
      },
      ...breadcrumbs,
      {
        slug: '',
        name: productInfo.title,
        uuid: 'product',
      },
    ]
  }

  mainStore.setContentLoadingStatus(true)
}

function closeFSSlider() {
  mainStore.toggleFSSlider(false)
  searchStore.clearSearchProductSlides()
}

await getProductInfo()
</script>

<template>
  <template v-if="product">
    <Breadcrumbs
      v-if="breadcrumbsList.length && !sizes?.isMobile"
      :breadcrumbs="breadcrumbsList"
    />
    <ProductBlock
      :product="product.productInfo"
      :min-price="product.minPrice"
    />
    <ClientOnly>
      <TableBlock
        v-if="product.minPrice"
        :article="product.productInfo.article"
        :brand="product.productInfo.brand.name"
      />
    </ClientOnly>
    <div :class="sizes.isMobile ? '' : 'container'">
      <SeoProductDescription
        v-if="mainStore.seoAdditionalText"
        :style="{ paddingInline: sizes.isMobile ? '20px' : '0' }"
        :additional-text="mainStore.seoAdditionalText"
      />
    </div>
    <Breadcrumbs
      v-if="breadcrumbsList.length && sizes?.isMobile"
      :breadcrumbs="breadcrumbsList"
    />
  </template>
  <Teleport to="body">
    <Transition name="fade">
      <FullScreenSlider
        v-if="mainStore.isFSSlider"
        :slides="searchStore.searchProductSlides"
        @close-slider="closeFSSlider"
      />
    </Transition>
  </Teleport>
</template>

<style lang="scss" scoped></style>
